module.exports = __webpack_public_path__ + "img/thumbnail_BighornSheep_f_leucistic.5c3d1790.png";